var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_125276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_125276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4 22.2665L22.2666 20.3998L17.3333 15.4665V9.33317H14.6666V16.5332L20.4 22.2665ZM16 29.3332C14.1555 29.3332 12.4222 28.9832 10.8 28.2832C9.17774 27.5832 7.76663 26.6332 6.56663 25.4332C5.36663 24.2332 4.41663 22.8221 3.71663 21.1998C3.01663 19.5776 2.66663 17.8443 2.66663 15.9998C2.66663 14.1554 3.01663 12.4221 3.71663 10.7998C4.41663 9.17761 5.36663 7.7665 6.56663 6.5665C7.76663 5.3665 9.17774 4.4165 10.8 3.7165C12.4222 3.0165 14.1555 2.6665 16 2.6665C17.8444 2.6665 19.5777 3.0165 21.2 3.7165C22.8222 4.4165 24.2333 5.3665 25.4333 6.5665C26.6333 7.7665 27.5833 9.17761 28.2833 10.7998C28.9833 12.4221 29.3333 14.1554 29.3333 15.9998C29.3333 17.8443 28.9833 19.5776 28.2833 21.1998C27.5833 22.8221 26.6333 24.2332 25.4333 25.4332C24.2333 26.6332 22.8222 27.5832 21.2 28.2832C19.5777 28.9832 17.8444 29.3332 16 29.3332ZM16 26.6665C18.9555 26.6665 21.4722 25.6276 23.55 23.5498C25.6277 21.4721 26.6666 18.9554 26.6666 15.9998C26.6666 13.0443 25.6277 10.5276 23.55 8.44984C21.4722 6.37206 18.9555 5.33317 16 5.33317C13.0444 5.33317 10.5277 6.37206 8.44996 8.44984C6.37218 10.5276 5.33329 13.0443 5.33329 15.9998C5.33329 18.9554 6.37218 21.4721 8.44996 23.5498C10.5277 25.6276 13.0444 26.6665 16 26.6665Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeTracking);
export default __webpack_public_path__ + "static/media/TimeTracking.4bd7ec057672df638bf09ff425208b26.svg";
export { ForwardRef as ReactComponent };